// Imports ------------------------------------------------------------------->

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

export function normalizeDate(str: string) {

	if (!str) {
		return new Date();
	}

	/* The Date object is JS is the worst and creates a timestamp relative to the client time.
		* Normalize the date as if it's in the current locale */
	const segments = str.split(/\D/).map((item) => Number(item));
	return new Date(segments[0], --segments[1], segments[2], segments[3], segments[4]);
}
